export default "__VITE_ASSET__B2dytpqT__"